import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Label } from 'reactstrap';
import { injectIntl } from 'react-intl';

import HelpIcon from '../HelpIcon';

import { userCan } from '../../helpers/Auth';
import { getSetting } from '../../helpers/Settings';

class UploadFileAccess extends PureComponent {
  constructor(props) {
    super(props);

    this.input = React.createRef();

    this.handleChangeValue = this.handleChangeValue.bind(this);
  }

  getAccessValue() {
    const {
      selectedFile,
      selectedFiles,
      isEdit,
    } = this.props;

    if (isEdit && selectedFiles.length > 1) {
      return this.input.value;
    }

    if (selectedFiles.length > 0) {
      if (selectedFiles[0].public) {
        return 'public';
      }
      return 'private';
    }

    if (selectedFile) {
      if (selectedFile.public) {
        return 'public';
      }
      return 'private';
    }

    return getSetting('default_file_access_type');
  }

  getOptions() {
    const {
      intl,
      isEdit,
      selectedFiles,
    } = this.props;

    const options = [];

    if (isEdit && selectedFiles.length > 1) {
      options.push({
        value: '',
        label: intl.formatMessage({ defaultMessage: '-- select --' }),
        icon: null,
      });
    }

    options.push({
      value: 'private',
      label: intl.formatMessage({ defaultMessage: 'Restricted' }),
      icon: 'fa-lock',
    });

    if (!getSetting('disable_public_files')) {
      options.push({
        value: 'public',
        label: intl.formatMessage({ defaultMessage: 'Open' }),
        icon: 'fa-eye',
      });
    }

    return options;
  }

  handleChangeValue(value) {
    const { handleFormChange } = this.props;

    handleFormChange({
      target: {
        name: 'fileAccess',
        value: value.value,
      },
    });
  }

  render() {
    const { intl, isLink } = this.props;

    return (
      <>
        <Label for="selectFileAccess">
          {intl.formatMessage({ defaultMessage: 'Visibility' })}
          {(!userCan('file.create_public') && this.getAccessValue() !== 'public') && (
            <HelpIcon>
              {isLink ? intl.formatMessage({ defaultMessage: 'You do not have the permissions to add public link cards' }) :
                intl.formatMessage({ defaultMessage: 'You do not have the permissions to add public files' })}
            </HelpIcon>
          )}
        </Label>
        <Select
          name="fileAccess"
          id="selectFileAccess"
          inputId="selectFileAccess"
          ref={this.input}
          className="file-access-select"
          classNamePrefix="file-access-select"
          getOptionLabel={e => (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ width: 16 }}>
                <i className={`fas ${e.icon}`} />
              </span>
              <span style={{ marginLeft: 5 }}>{e.label}</span>
            </div>
          )}
          options={this.getOptions()}
          onChange={this.handleChangeValue}
          defaultValue={this.getOptions().find(o => (o.value === this.getAccessValue()))}
          disabled={!userCan('file.create_public') && this.getAccessValue() !== 'public'}
          isSearchable={false}
        />
      </>
    );
  }
}

UploadFileAccess.propTypes = {
  intl: PropTypes.object.isRequired,
  isEdit: PropTypes.bool.isRequired,
  isLink: PropTypes.bool.isRequired,
  selectedFile: PropTypes.object,
  selectedFiles: PropTypes.array.isRequired,
  handleFormChange: PropTypes.func.isRequired,
};

UploadFileAccess.defaultProps = {
  selectedFile: null,
};

export default injectIntl(UploadFileAccess);
